/**
 * 数据集合定义 + 索引声明（单一事实来源）
 * ------------------------------------------------------------
 * - 集合名、主键、索引全部集中在这里；
 * - IndexedDB / 未来云端适配器都读这份声明来建表/建索引；
 * - 新增一种内容类型：这里加一条 + models.js 加工厂函数即可。
 */

export const COLLECTIONS = {
  META: 'meta',
  TEXTBOOKS: 'textbooks',
  UNITS: 'units',
  WORDS: 'words',
  SENTENCES: 'sentences',
  GRAMMAR: 'grammar',
  QUESTIONS: 'questions',
  STUDENTS: 'students',
  SESSIONS: 'sessions',
  ANSWERS: 'answers',
  ERRORS: 'errors',
  MASTERY: 'mastery',
  ACHIEVEMENTS: 'achievements',
  IMPORTS: 'imports',
  LIBRARY: 'library',   // 资料库：PDF 清单的用户确认状态
};

export const SCHEMA_VERSION = 3;   // v3：新增 library 表（资料库确认状态）

/** keyPath + indexes 声明（供 IndexedDB 建库使用） */
export const STORE_SCHEMA = {
  [COLLECTIONS.META]: { keyPath: 'key' },
  [COLLECTIONS.TEXTBOOKS]: { keyPath: 'id', indexes: ['grade'] },
  [COLLECTIONS.UNITS]: { keyPath: 'id', indexes: ['textbookId'] },
  [COLLECTIONS.WORDS]: { keyPath: 'id', indexes: ['unitId', 'textbookId', 'en'] },
  [COLLECTIONS.SENTENCES]: { keyPath: 'id', indexes: ['unitId', 'textbookId'] },
  [COLLECTIONS.GRAMMAR]: { keyPath: 'id', indexes: ['unitId', 'category'] },
  [COLLECTIONS.QUESTIONS]: { keyPath: 'id', indexes: ['unitId', 'type', 'skill', 'status'] },
  [COLLECTIONS.STUDENTS]: { keyPath: 'id' },
  [COLLECTIONS.SESSIONS]: { keyPath: 'id', indexes: ['studentId', 'unitId', 'module', 'endedAt'] },
  [COLLECTIONS.ANSWERS]: { keyPath: 'id', indexes: ['sessionId', 'questionId'] },
  [COLLECTIONS.ERRORS]: { keyPath: 'id', indexes: ['studentId', 'refId', 'status', 'unitId'] },
  [COLLECTIONS.MASTERY]: { keyPath: 'key', indexes: ['unitId', 'refType'] },
  [COLLECTIONS.ACHIEVEMENTS]: { keyPath: 'id', indexes: ['studentId', 'code'] },
  [COLLECTIONS.IMPORTS]: { keyPath: 'id', indexes: ['status'] },
  [COLLECTIONS.LIBRARY]: { keyPath: 'id' },
};

/** 内容集合（可被导入/导出，业务数据不含在内） */
export const CONTENT_COLLECTIONS = [
  COLLECTIONS.TEXTBOOKS, COLLECTIONS.UNITS, COLLECTIONS.WORDS,
  COLLECTIONS.SENTENCES, COLLECTIONS.GRAMMAR, COLLECTIONS.QUESTIONS,
];

/** 学习数据集合（含学生个人数据，导出备份用） */
export const LEARNING_COLLECTIONS = [
  COLLECTIONS.STUDENTS, COLLECTIONS.SESSIONS, COLLECTIONS.ANSWERS,
  COLLECTIONS.ERRORS, COLLECTIONS.MASTERY, COLLECTIONS.ACHIEVEMENTS,
];
